import { safeRelativePath } from '@savage/auth/portal';

/** Navigation only. Destination loaders must still enforce session/client scope. */
export function reportingReturnDestination(value: string | null | undefined) {
  const fallback = { clientPath: '/boards', callbackPath: '/reporting/boards' };
  const path = safeRelativePath(value, '/boards');
  if (/[\\\u0000-\u001f\u007f]/.test(path)) return fallback;
  const prefixed = /^\/reporting(?:\/|\?|#|$)/.test(path)
    ? path : `/reporting${path}`;
  const destination = new URL(prefixed, 'https://reporting.invalid');
  if (destination.origin !== 'https://reporting.invalid'
    || !/^\/reporting(?:\/|$)/.test(destination.pathname)
    || /%(?:2f|5c)/i.test(destination.pathname)) return fallback;
  const localPath = destination.pathname.slice('/reporting'.length) || '/';
  if (/^\/(?:login|signup|forgot-password|auth)(?:\/|$)/.test(localPath)) return fallback;
  const suffix = `${destination.search}${destination.hash}`;
  return {
    clientPath: `${localPath}${suffix}`,
    callbackPath: `${destination.pathname}${suffix}`,
  };
}
